module.exports = __webpack_public_path__ + "img/xmasParty16.fe26e698.jpg";